import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { RouterModule } from "@angular/router";

import { SharedModule } from "./shared/shared.module";
import { NavMenuModule } from "./core/components/navmenu/navmenu.module";
import { LoadingBarModule } from "./shared/components/loading-bar/loading-bar.module";

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    SharedModule,
    NavMenuModule,
    LoadingBarModule,
  ],
  exports: [
    CommonModule,
    RouterModule,
    SharedModule,
    NavMenuModule,
    LoadingBarModule,
  ],
})
export class AppModuleShared {}
